import { 
  REQUEST_AUTOCOMPLETE, 
  RECEIVE_AUTOCOMPLETE,
  FAIL_AUTOCOMPLETE, 
  CLEAR_AUTOCOMPLETE,
} from "../actions/autoComplete";

export default function autoComplete(state = {
  loading: false,
  loaded: false,
  items: [],
}, action) {
  switch (action.type) {
    case CLEAR_AUTOCOMPLETE:
      return {
        ...state,
        loading: false,
        loaded: false,
        items: [],
      };
    case REQUEST_AUTOCOMPLETE:
      return {
        ...state,
        loading: true,
      };
    case RECEIVE_AUTOCOMPLETE:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: [...action.payload.items],
        lastUpdated: action.payload.receivedAt,
      };
    case FAIL_AUTOCOMPLETE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}